export default class CreateSaleOrderRequestLineDto {
    orderNo:number;
    sku: string;
    productId:number;
    productName:string;
    orderQty: number;
    productPrice:number;
    price: number;
    vatPercent: number;
    productType:string;
}